module.exports = __webpack_public_path__ + "img/eq-belt.ce14044f.png";